import { actions } from '../constants'

export const initial = {}

export default function (state = initial, { type, payload }) {
  switch (type) {
    case actions.data.FETCH_SUCCESS:
      return {
        ...state,
        [payload.page]: payload.data,
      }

    case actions.RESET_TAB:
      return {
        ...state,
        [payload.page]: undefined,
      }

    case actions.CLEAR_ERRORS:
      return {
        ...state,
        error: undefined,
      }

    case actions.data.FETCH_FAILURE:
      return {
        ...state,
        error: payload.error,
      }

    default:
      return state
  }
}
